import React, { Component } from 'react';
import { isLoaded, isEmpty } from 'react-redux-firebase';
import Wish from 'components/Wish';
import AddWish from 'components/AddWish';
import Masonry from 'react-masonry-css';
import Strings from 'components/Strings';
import './wishes.css';

class Wishes extends Component {
  constructor() {
    super();
    this.masonryRef = React.createRef();
  }

  componentDidUpdate() {
    const masonry = this.masonryRef.current;
    masonry && masonry.reCalculateColumnCount();
  }

  renderEmpty() {
    return 'You have no wishes.'
  }

  renderWishes() {
    const { wishes, widthOffset } = this.props;

    const breakpointCols = {
      default: 4,
      [1200 + widthOffset]: 3,
      [900 + widthOffset]: 2,
      [650 + widthOffset]: 1
    };

    return (
      <Masonry ref={ this.masonryRef } breakpointCols={ breakpointCols } className="Wishes-Masonry" columnClassName="Wishes-column">
        { !!wishes.map && wishes.map(wish => this.renderItem(wish)) }
      </Masonry>
    )
  }

  renderItem(wish) {
    return (
      <div className="Wishes-item" key={ wish.key }>
        <Wish wishId={ wish.key } />
      </div>
    )
  }

  renderLoading() {
    return <Strings label="loading" />
  }

  render() {
    const { wishes, isAdmin } = this.props;

    return (
      <div className="Wishes">
        { isAdmin && <AddWish /> }
        {
          isLoaded(wishes)
          ? isEmpty(wishes)
            ? this.renderEmpty()
            : this.renderWishes()
          : this.renderLoading()
        }
      </div>
    )
  }
}

export default Wishes;



// WEBPACK FOOTER //
// ./src/components/Wishes/Wishes.js